import React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
export const NextImg = ({
  NextImage,
  priority = true,
  src,
  alt,
  ...rest
}) => NextImage ? /*#__PURE__*/_jsx(NextImage, {
  priority: priority,
  alt: alt,
  src: src,
  ...rest
}) : /*#__PURE__*/_jsx("img", {
  alt: alt,
  src: src,
  ...rest
});